import { BrowserRouter, Routes, Route } from "react-router-dom";
import SiteLayout from "@/site/SiteLayout";
import Home from "@/site/pages/Home";
import About from "@/site/pages/About";
import Portfolio from "@/site/pages/Portfolio";
import Contact from "@/site/pages/Contact";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminReset from "@/pages/AdminReset";
import VendorPricing from "@/pages/VendorPricing";
import StudioLayout from "@/studio/StudioLayout";
import StudioDashboard from "@/studio/pages/Dashboard";
import Clients from "@/studio/pages/Clients";
import ClientProfile from "@/studio/pages/ClientProfile";
import Projects from "@/studio/pages/Projects";
import ProjectPage from "@/studio/pages/ProjectPage";
import Settings from "@/studio/pages/Settings";
import Review from "@/studio/pages/Review";
import Consultation from "@/studio/pages/Consultation";
import ClientPage from "@/client/ClientPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route element={<SiteLayout />}>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/portfolio" element={<Portfolio />} />
            <Route path="/contact" element={<Contact />} />
          </Route>
          <Route path="/vendor-pricing" element={<VendorPricing />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/admin/reset" element={<AdminReset />} />
          <Route path="/p/:token" element={<ClientPage />} />
          <Route path="/admin/studio" element={<StudioLayout />}>
            <Route index element={<StudioDashboard />} />
            <Route path="clients" element={<Clients />} />
            <Route path="clients/:id" element={<ClientProfile />} />
            <Route path="projects" element={<Projects />} />
            <Route path="projects/:id" element={<ProjectPage />} />
            <Route path="consultations/:id" element={<Consultation />} />
            <Route path="settings" element={<Settings />} />
            <Route path="review" element={<Review />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
